import {
  LegalPage,
  Main,
  PrivacySection,
  Header as PrivacyPageHeader,
  PrivacyPageWrapper,
  SubContent,
  SubParagraph,
  Subtitle,
  Title,
  Paragraph,
} from "./styled";
import { privacyPageCopy } from "components/Copy/privacyCopyObject";
import { FunctionComponent, Fragment } from "react";

const PrivacyPage: FunctionComponent = () => {
  return (
    <div style={{ height: "100%", width: "100%", backgroundColor: "#fff" }}>
      <LegalPage>
        <PrivacyPageWrapper>
          <PrivacyPageHeader>
            <Title>Privacy Policy</Title>
            <Paragraph>{privacyPageCopy.headerText.paragraph}</Paragraph>
          </PrivacyPageHeader>
          <Main>
            <SubContent>
              {privacyPageCopy.subContent.map((item: any, index: number) => (
                <PrivacySection key={`section${index}`}>
                  <Subtitle>{item.subtitle}</Subtitle>
                  <SubParagraph>
                    {item.subParagraphs.map((para: any, index: number) => (
                      <Fragment key={`span${index}`}>{para}</Fragment>
                    ))}
                  </SubParagraph>
                </PrivacySection>
              ))}
            </SubContent>
          </Main>
        </PrivacyPageWrapper>
      </LegalPage>
    </div>
  );
};

export default PrivacyPage;
